import { FC } from 'react'
import { CopyOutlined } from '@ant-design/icons'
import cn from './index.module.css'
import { useAddAlert } from '@/hooks/useAddAlert'
import classNames from 'classnames'

interface ILinkView {
  className?: string
  link: string
  alertText?: string
  onClick?: (e: React.MouseEvent) => void
}

const LinkView: FC<ILinkView> = ({
  className,
  link,
  alertText = 'Ссылка скопирована',
  onClick,
}) => {
  const addAlert = useAddAlert()

  const onClickDefault = () => {
    addAlert({ title: alertText })
    navigator.clipboard.writeText(link)
  }

  return (
    <div
      className={classNames(cn.linkWrapper, className)}
      onClick={onClick ?? onClickDefault}
    >
      <div className={cn.link}>
        <span className={cn.linkText}>{link}</span>
      </div>
      <CopyOutlined
        className={cn.copyIcon}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      />
    </div>
  )
}

export default LinkView
